/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDimensions_filters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_filters">;
    readonly " $refType": "SbRespRefineMenuFilterDimensions_filters";
}>;
export type SbRespRefineMenuFilterDimensions_filters$data = SbRespRefineMenuFilterDimensions_filters;
export type SbRespRefineMenuFilterDimensions_filters$key = ReadonlyArray<{
    readonly " $data"?: SbRespRefineMenuFilterDimensions_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterDimensions_filters">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespRefineMenuFilterDimensions_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};
(node as any).hash = 'da120dcca3c094f9a082023bad3bbb40';
export default node;
